export default __webpack_public_path__ + "static/media/uniswapWalletBannerLight.9629a31d.png";